'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestedMeetingsLinksFailed = exports.receivedMeetingsLinks = exports.requestedMeetingsLinks = exports.clickedMeetingsLink = undefined;
exports.fetchAllMeetingsLinks = fetchAllMeetingsLinks;

var _reduxActions = require('redux-actions');

var _immutable = require('immutable');

var _Schemas = require('conversations-core/data/Schemas');

var _normalizr = require('normalizr');

var _MessagesClient = require('conversations-core/data/MessagesClient');

var _fromJSReviver = require('conversations-core/utils/fromJSReviver');

var _fromJSReviver2 = _interopRequireDefault(_fromJSReviver);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clickedMeetingsLink = exports.clickedMeetingsLink = (0, _reduxActions.createAction)(_ActionTypes2.default.CLICKED_MEETINGS_LINK);

var requestedMeetingsLinks = exports.requestedMeetingsLinks = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_MEETINGS_LINKS);

var receivedMeetingsLinks = exports.receivedMeetingsLinks = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_MEETINGS_LINKS_SUCCEEDED, function (meetingsLinks) {
  return {
    response: (0, _immutable.fromJS)((0, _normalizr.normalize)(meetingsLinks, (0, _normalizr.arrayOf)(_Schemas.meetingsLink)), _fromJSReviver2.default)
  };
});

var requestedMeetingsLinksFailed = exports.requestedMeetingsLinksFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_MEETINGS_LINKS_FAILED, function (error) {
  return { error: error };
});

function fetchAllMeetingsLinks() {
  return function (dispatch) {
    dispatch(requestedMeetingsLinks());
    (0, _MessagesClient.fetchMeetingsLinks)().then(function (meetingsLinks) {
      dispatch(receivedMeetingsLinks(meetingsLinks));
    }, function (err) {
      dispatch(requestedMeetingsLinksFailed(err));
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/MeetingsActions.js
// module id = 270
// module chunks = 0 1